import PreventService from './PreventService';

export default new PreventService();
